import general from './general'
import elementUI from 'element-ui/lib/locale/lang/fr'

const messages = { general, ...elementUI }

export default messages



// WEBPACK FOOTER //
// ./src/lang/ja/index.js